var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Grid } from "@mui/material";
import { useRef } from "react";
import * as helperPDF from "../../Biblioteca/helperPDF";
export default function BaseGraficoPDF({ idGraph, GraphComponent, GraphComponentsProps, docObj, config, containerWidth, containerHeight, createPDFGraph, sendComponent, theme, extraComponent, useGraphSize = false, }) {
    function createComponentPDF() {
        return __awaiter(this, void 0, void 0, function* () {
            const htmlElement = containerRef.current;
            const svg = helperPDF.getSvgFromRecharts(htmlElement, theme);
            const componentGraphObj = createPDFGraph(svg);
            const component = yield componentGraphObj.criarGrafico(docObj);
            let graphComponent = [component];
            if (extraComponent) {
                if (useGraphSize) {
                    extraComponent[0].config.size = component === null || component === void 0 ? void 0 : component.config.size;
                }
                graphComponent.push(...extraComponent);
            }
            sendComponent(idGraph, graphComponent);
        });
    }
    // evitar loading infinito se o grafico nao possui dados
    if (!GraphComponentsProps.data || GraphComponentsProps.data.length === 0 || (GraphComponentsProps.data[0].value !== undefined && isNaN(GraphComponentsProps.data[0].value))) {
        sendComponent(idGraph, []);
    }
    const containerRef = useRef(null);
    return (_jsx(Grid, Object.assign({ width: containerWidth, height: containerHeight, fontSize: theme.xlFontSizePDF, ref: (el) => (containerRef.current = el) }, { children: _jsx(GraphComponent, Object.assign({}, GraphComponentsProps, { handleOnAnimationEnd: () => createComponentPDF(), dispatchPDF: true })) }), idGraph));
}
